import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import FooterMain from "@shared/components/Atoms/Contents/FooterMain";
import MainNav from "@shared/components/Atoms/MainNav";
import { APP_NAME, BLOG_LABEL } from "@shared/util/brand";
import "../Home/Home.css";

function formatDate(dateStr) {
  if (!dateStr) return "";
  try {
    return new Date(dateStr).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  } catch {
    return dateStr;
  }
}

function BlogIndex() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${import.meta.env.VITE_API_URL}/blog`)
      .then((res) => setPosts(res.data))
      .catch(() => setError("Failed to load posts."))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="home-page">
      <MainNav />
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-3xl mx-auto mt-[80px] mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-2">{BLOG_LABEL}</h1>
          <p className="text-gray-500 mb-10">Insights and updates from the {APP_NAME} team.</p>

          {loading && (
            <div className="flex justify-center py-16">
              <div className="w-8 h-8 border-4 border-gray-200 border-t-gray-600 rounded-full animate-spin" />
            </div>
          )}

          {error && (
            <div className="text-red-500 py-8 text-center">{error}</div>
          )}

          {!loading && !error && posts.length === 0 && (
            <p className="text-gray-500 py-8 text-center">No posts yet. Check back soon.</p>
          )}

          <div className="space-y-8">
            {posts.map((post) => (
              <article
                key={post.slug}
                className="border border-gray-200 rounded-xl p-6 hover:shadow-md transition-shadow"
              >
                <Link to={`/blog/${post.slug}`} className="group">
                  <h2 className="text-2xl font-semibold text-gray-900 group-hover:text-blue-600 transition-colors mb-2">
                    {post.title}
                  </h2>
                </Link>

                <div className="flex items-center gap-3 text-sm text-gray-400 mb-3">
                  {post.date && <span>{formatDate(post.date)}</span>}
                  {post.author && (
                    <>
                      <span>·</span>
                      <span>{post.author}</span>
                    </>
                  )}
                </div>

                {post.description && (
                  <p className="text-gray-600 mb-4">{post.description}</p>
                )}

                {post.tags && post.tags.length > 0 && (
                  <div className="flex flex-wrap gap-2 mb-4">
                    {post.tags.map((tag) => (
                      <span
                        key={tag}
                        className="px-2 py-1 bg-gray-100 text-gray-500 text-xs rounded-md"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                )}

                <Link
                  to={`/blog/${post.slug}`}
                  className="text-blue-600 text-sm font-medium hover:underline"
                >
                  Read more →
                </Link>
              </article>
            ))}
          </div>
        </div>
      </div>
      <FooterMain />
    </div>
  );
}

export default BlogIndex;
